// services/categoryService.js
import axios from "../utils/axiosConfig";
import config from "../config/config";
import { handleApiError } from "../utils/errorHandler";

const BASE_URL = `${config.apiUrl}/api/categories`;

export const categoryService = {
  async listCategories() {
    try {
      const response = await axios.get(`${BASE_URL}/list`);

      // Separar las categorías por destino
      const categories = response.data.data || [];
      const drinks = categories.filter(
        (cat) =>
          cat.destination.toLowerCase() === "bebidas" ||
          cat.destination.toLowerCase() === "barra"
      );
      const kitchen = categories.filter(
        (cat) => cat.destination.toLowerCase() === "cocina"
      );

      return {
        success: true,
        data: {
          drinks,
          kitchen,
        },
        message: response.data.message || "Categorías obtenidas exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: { drinks: [], kitchen: [] },
        message: apiError.message,
      };
    }
  },

  getCategoriesByType(categories, type) {
    if (!categories) return [];
    return type === "bebidas" ? categories.drinks : categories.kitchen;
  },

  getCategories: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/list`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Categorías obtenidas exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  createCategory: async (categoryData) => {
    try {
      // Si hay un archivo de imagen, usar FormData
      const formData = new FormData();
      Object.keys(categoryData).forEach((key) => {
        if (key === "imagen" && categoryData[key]) {
          formData.append("image", categoryData[key]);
        } else {
          formData.append(key, categoryData[key]);
        }
      });

      const response = await axios.post(`${BASE_URL}/add`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Categoría creada exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  updateCategory: async (id, categoryData) => {
    try {
      const formData = new FormData();
      Object.keys(categoryData).forEach((key) => {
        if (key === "imagen" && categoryData[key]) {
          formData.append("image", categoryData[key]);
        } else {
          formData.append(key, categoryData[key]);
        }
      });

      const response = await axios.put(`${BASE_URL}/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Categoría actualizada exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${id}`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Categoría eliminada exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },
};
